export default {
  url: "https://admin.bsv-harsewinkel.de/",
  token: "account-666c1c0dababe642252ff43b44fcba",
  thumb:
    "https://admin.bsv-harsewinkel.de/api/cockpit/image?token=account-666c1c0dababe642252ff43b44fcba&rspc=1&w=800&m=fitToHeight&q=86&o=1&src=",
};
